var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 32.5,
    viewBox: "0 0 32.5 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31821",
    "data-name": "Grupo 31821",
    transform: "translate(16686.25 7083.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17992",
    "data-name": "Grupo 17992",
    transform: "translate(-16622 -7077.543)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-64 -5.544)",
    fill: "#fff",
    stroke: "#65a518",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Env\\xEDo_de_E-mail",
    "data-name": "Env\\xEDo de E-mail",
    transform: "translate(-16670 -7066.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-8 -5.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13107",
    "data-name": "Trazado 13107",
    d: "M15.6,0H.382A.381.381,0,0,0,0,.382v9.727a.38.38,0,0,0,.382.382H15.618A.381.381,0,0,0,16,10.109V.4A.418.418,0,0,0,15.6,0ZM11.656,5.108l-.593.486,3.411,4.133H1.336L4.79,5.551,4.2,5.065.764,9.22V1.379L7.991,7.312l7.223-6.019V9.452ZM1.25.786H14.621L7.991,6.294Z",
    fill: "#006729"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6f62483bfba8659c891a494174a85a50.svg";
export { ForwardRef as ReactComponent };